import {
  DialogCloseButton, DialogLogOutButton,
  DialogProfileContent,
  DialogProfileField,
  DialogProfileName,
  DialogWrapper, NavLinkToProfile
} from "./Profile.styled";
import {TransitionProps} from "@mui/material/transitions";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide
} from "@mui/material";
import {forwardRef, PropsWithChildren, useState} from "react";
import {CloseModalIcon} from "../../assets/svg/closeModalIcon";
import {useProfileContext} from "../../context/profileContext";
import {AvatarIcon} from "../../assets/svg/avatarIcon";
import {useAuthContext} from "../../context/authContext";
import {useMutation} from "@tanstack/react-query";
import Api from "../api/api";

const Transition = forwardRef(function Transition(
  props: PropsWithChildren<TransitionProps> & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export function Profile() {
  const [open, setOpen] = useState<boolean>(false);

  const api = Api();

  const { profile } = useProfileContext();
  const { setAccessToken } = useAuthContext();

  const { mutate } = useMutation({
    mutationKey: ['logout'],
    mutationFn: async () => {
      await api.logout();
      setAccessToken('');
    },
  });

  const handleLogout = () => {
    mutate();
    handleClose()
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <DialogWrapper>
      <NavLinkToProfile variant={'outlined'} startIcon={<AvatarIcon/>} onClick={handleClickOpen}>{profile.full_name}</NavLinkToProfile>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogActions>
          <DialogCloseButton onClick={handleClose}><CloseModalIcon /></DialogCloseButton>
        </DialogActions>
        <DialogTitle sx={{ fontSize: '56px', p: '0' }}>{'Profile'}</DialogTitle>
        <DialogContent sx={{ mb: '24px' }}>
          <DialogProfileContent>
            <DialogProfileField>Name</DialogProfileField>
            <DialogProfileName>{profile.full_name}</DialogProfileName>
          </DialogProfileContent>
          <DialogProfileContent>
            <DialogProfileField>Email</DialogProfileField>
            <DialogProfileName>{profile.email}</DialogProfileName>
          </DialogProfileContent>
          <DialogProfileContent>
            <DialogProfileField>Auth provider</DialogProfileField>
            <DialogProfileName>{profile.auth_provider}</DialogProfileName>
          </DialogProfileContent>
          <DialogProfileContent>
            <DialogProfileField>Available balance</DialogProfileField>
            <DialogProfileName>{profile.available_balance}</DialogProfileName>
          </DialogProfileContent>
          <DialogProfileContent>
            <DialogProfileField>Total balance</DialogProfileField>
            <DialogProfileName>{profile.total_balance}</DialogProfileName>
          </DialogProfileContent>
          <DialogProfileContent>
            <DialogProfileField>Status</DialogProfileField>
            <DialogProfileName>{profile.status}</DialogProfileName>
          </DialogProfileContent>
        </DialogContent>
        <DialogActions>
          <DialogLogOutButton variant={'outlined'} onClick={handleLogout}>Log out</DialogLogOutButton>
        </DialogActions>
      </Dialog>
    </DialogWrapper>
  )
}